<template>
  <v-app>
    <Header />
    <v-main>
      <router-view />
    </v-main>
    <v-footer app class="bg-black text-white">
      <v-container>
        <div class="text-center">
          &copy; {{ currentYear }} — <strong>RankCrew</strong> — AI-driven SEO content creation
        </div>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
import Header from './components/Header.vue'
import { useAuthStore } from './stores/auth'
import { onMounted } from 'vue'

export default {
  name: 'App',
  components: {
    Header
  },
  setup() {
    const authStore = useAuthStore()
    
    onMounted(async () => {
      console.log('App mounted, checking authentication...')
      if (authStore.token) {
        // Validate the token on app startup
        const isValid = await authStore.validateSession()
        console.log('Initial auth validation result:', isValid)
      } else {
        console.log('No token found on app startup')
      }
    })
    
    return {
      currentYear: new Date().getFullYear()
    }
  }
}
</script>

<style>
#app {
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #ffffff;
}

.text-white {
  color: white !important;
}

.text-black {
  color: black !important;
}

.rounded-xl {
  border-radius: 16px !important;
}

/* Add smooth transitions to all elements */
* {
  transition: all 0.25s ease;
}
</style>
